"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalToExternalTypeMap = exports.externalToInternalTypeMap = void 0;
var types_1 = require("../../actions/internal/types");
var types_2 = require("../../actions/external/types");
var eventSearch_1 = require("../../actions/internal/eventSearch");
var eventStatus_1 = require("../../actions/internal/eventStatus");
var eventSearch_2 = require("../../actions/external/eventSearch");
var eventStatus_2 = require("../../actions/external/eventStatus");
exports.externalToInternalTypeMap = (_a = {},
    _a[types_2.EventActionTypes.EVENT_STATUS_CHANGE] = function (action) { return eventStatus_1.eventStatusChangeInternal(action); },
    _a[types_2.EventActionTypes.EVENT_SEARCH] = function (action) { return eventSearch_1.eventSearchInternal(action); },
    _a['undefined'] = undefined,
    _a);
exports.internalToExternalTypeMap = (_b = {},
    _b[types_1.InternalClientActionType.EVENT_STATUS_CHANGE_COMPLETE] = function (action) {
        return eventStatus_2.eventStatusChangeComplete(action);
    },
    _b[types_1.InternalClientActionType.EVENT_STATUS_CHANGE_ERROR] = function (action) {
        return eventStatus_2.eventStatusChangeError(action);
    },
    _b[types_1.InternalClientActionType.EVENT_SEARCH_COMPLETE] = function (action) {
        return eventSearch_2.eventSearchComplete(action);
    },
    _b[types_1.InternalClientActionType.EVENT_SEARCH_ERROR] = function (action) {
        return eventSearch_2.eventSearchError(action);
    },
    _b['undefined'] = undefined,
    _b);
//# sourceMappingURL=actionMapper.js.map